module.exports = __webpack_public_path__ + "static/media/children_hospital_mural_concept_2_2003.6fd0608e.webp";